import { render, staticRenderFns } from "./OfferDelivery.vue?vue&type=template&id=bd5520b6&"
import script from "./OfferDelivery.vue?vue&type=script&lang=js&"
export * from "./OfferDelivery.vue?vue&type=script&lang=js&"
import style0 from "./OfferDelivery.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OfferDelivery.vue?vue&type=style&index=1&lang=css&"
import style2 from "./OfferDelivery.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports